(function () {
  "use strict";

  var configEl = document.getElementById("bb-config");
  var config = configEl ? JSON.parse(configEl.textContent) : { routes: {}, moneyFormat: "${{amount}}" };
  var routes = config.routes || {};

  function clamp(n, a, b) {
    return Math.max(a, Math.min(b, n));
  }

  function formatMoney(cents) {
    var format = String(config.moneyFormat || "${{amount}}").replace(/<[^>]*>/g, "");
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(cents / 100));
    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(".", ","))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function gate(p, from, to) {
    var fade = 0.1;
    var inn = from <= 0.001 ? 1 : clamp((p - (from - fade)) / fade, 0, 1);
    var out = to >= 0.999 ? 1 : clamp((to - p) / fade, 0, 1);
    return Math.min(inn, out);
  }

  var topbar = document.querySelector("[data-top]");
  function measureTop() {
    if (!topbar) return;
    document.documentElement.style.setProperty("--top-h", topbar.offsetHeight + "px");
  }
  measureTop();
  window.addEventListener("resize", measureTop, { passive: true });

  var announceClose = document.querySelector("[data-announce-close]");
  if (announceClose) {
    announceClose.addEventListener("click", function () {
      var bar = document.querySelector("[data-announce]");
      if (bar) bar.remove();
      try { sessionStorage.setItem("bb-announce", "1"); } catch (err) { /* ignore */ }
      measureTop();
    });
  }

  var nav = document.querySelector("[data-nav]");
  var burger = document.querySelector("[data-burger]");
  function setNav(open) {
    if (!nav || !burger) return;
    nav.hidden = !open;
    burger.setAttribute("aria-expanded", open ? "true" : "false");
    document.body.style.overflow = open ? "hidden" : "";
    if (open) {
      var first = nav.querySelector("a, button");
      if (first) first.focus();
    }
  }
  if (nav) {
    document.querySelectorAll("[data-burger]").forEach(function (btn) {
      btn.addEventListener("click", function () { setNav(nav.hidden); });
    });
    nav.addEventListener("click", function (event) {
      if (event.target.closest("a")) setNav(false);
    });
  }

  var drawer = document.querySelector("[data-cart-drawer]");
  var cartBody = document.querySelector("[data-cart-body]");
  var cartSubtotal = document.querySelector("[data-cart-subtotal]");
  var cartFoot = document.querySelector("[data-cart-foot]");
  var lastFocus = null;

  function setCartOpen(open) {
    if (!drawer) return;
    drawer.hidden = !open;
    document.body.style.overflow = open ? "hidden" : "";
    if (open) {
      lastFocus = document.activeElement;
      var close = drawer.querySelector("[data-cart-close]");
      if (close) close.focus();
    } else if (lastFocus && lastFocus.focus) {
      lastFocus.focus();
    }
  }

  document.querySelectorAll("[data-cart-open]").forEach(function (btn) {
    btn.addEventListener("click", function () { setCartOpen(true); });
  });
  document.querySelectorAll("[data-cart-close]").forEach(function (btn) {
    btn.addEventListener("click", function () { setCartOpen(false); });
  });

  function extensionData() {
    var el = document.getElementById("bb-extension");
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (err) { return null; }
  }

  function renderCart(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = String(cart.item_count || 0);
      el.dataset.empty = cart.item_count ? "false" : "true";
    });
    if (!cartBody) return;
    if (!cart.items || !cart.items.length) {
      cartBody.innerHTML = '<p class="bb-lede">Nothing in here yet.</p><p style="margin-top:14px"><a class="bb-btn" href="' + escapeHtml(routes.kit || "/collections/all") + '">Shop the kit</a></p>';
      if (cartFoot) cartFoot.hidden = true;
      return;
    }
    if (cartFoot) cartFoot.hidden = false;
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);

    var html = cart.items.map(function (item) {
      var variant = item.variant_title && item.variant_title !== "Default Title"
        ? "<p>" + escapeHtml(item.variant_title) + "</p>" : "";
      return (
        '<article class="bb-cartitem">' +
          '<img src="' + escapeHtml(item.image || "") + '" alt="" width="72" height="72">' +
          "<div>" +
            '<a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + "</a>" +
            variant +
            "<p>" + formatMoney(item.final_line_price) + "</p>" +
            '<div class="bb-miniqty">' +
              '<label class="bb-visually-hidden" for="qty-' + escapeHtml(item.key) + '">Quantity</label>' +
              '<input id="qty-' + escapeHtml(item.key) + '" data-qty="' + escapeHtml(item.key) + '" type="number" min="0" value="' + item.quantity + '">' +
              '<button class="bb-linkish" type="button" data-remove="' + escapeHtml(item.key) + '">Remove</button>' +
            "</div>" +
          "</div>" +
        "</article>"
      );
    }).join("");

    var ext = extensionData();
    var hasKit = config.kitId && cart.items.some(function (item) { return item.product_id === config.kitId; });
    var hasExt = config.extensionId && cart.items.some(function (item) { return item.product_id === config.extensionId; });
    if (ext && hasKit && !hasExt && ext.variants && ext.variants.length) {
      var options = ext.variants.map(function (variant) {
        return '<option value="' + variant.id + '"' + (variant.available ? "" : " disabled") + ">" +
          escapeHtml(variant.title) + " · " + formatMoney(variant.price) + "</option>";
      }).join("");
      html += '<div class="bb-upsell" data-upsell><p><strong>While you are here.</strong> A matching extension screws on later, or you can add one now.</p>' +
        "<label>Size <select>" + options + "</select></label>" +
        '<button class="bb-btn" type="button" data-add-variant>Add extension</button></div>';
    }
    cartBody.innerHTML = html;
  }

  function fetchCart() {
    return fetch(routes.cart + ".js", { headers: { Accept: "application/json" } }).then(function (res) { return res.json(); });
  }

  function changeLine(key, quantity) {
    return fetch(routes.cartChange + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (res) { return res.json(); }).then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  function addVariant(id, quantity) {
    return fetch(routes.cartAdd + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: id, quantity: quantity || 1 })
    }).then(function (res) {
      if (!res.ok) throw new Error("add failed");
      return fetchCart();
    });
  }

  if (cartBody) {
    cartBody.addEventListener("change", function (event) {
      var input = event.target.closest("[data-qty]");
      if (!input) return;
      changeLine(input.dataset.qty, Number(input.value));
    });
    cartBody.addEventListener("click", function (event) {
      var remove = event.target.closest("[data-remove]");
      if (remove) {
        changeLine(remove.dataset.remove, 0);
        return;
      }
      var add = event.target.closest("[data-add-variant]");
      if (!add) return;
      var select = add.parentElement.querySelector("select");
      if (!select) return;
      add.disabled = true;
      addVariant(Number(select.value), 1).then(function (cart) {
        renderCart(cart);
      }).catch(function () {
        add.disabled = false;
      });
    });
  }

  var cartJson = document.getElementById("bb-cart-json");
  if (cartJson) {
    try { renderCart(JSON.parse(cartJson.textContent)); } catch (err) { /* keep server markup */ }
  }

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    if (drawer && !drawer.hidden) setCartOpen(false);
    if (nav && !nav.hidden) setNav(false);
  });

  function initProduct() {
    var form = document.getElementById("ProductForm");
    var dataEl = document.querySelector("[data-product-json]");
    if (!form || !dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var variants = product.variants || [];
    var idInput = form.querySelector("[name='id']");
    var priceEl = document.querySelector("[data-product-price]");
    var compareEl = document.querySelector("[data-product-compare]");
    var priceMobile = document.querySelector("[data-product-price-mobile]");
    var addBtn = form.querySelector("[data-add]");
    var optionSelects = form.querySelectorAll("[data-option-index]");

    function currentVariant() {
      if (optionSelects.length) {
        var selected = [];
        optionSelects.forEach(function (sel) { selected[Number(sel.dataset.optionIndex)] = sel.value; });
        return variants.find(function (variant) {
          return selected.every(function (value, index) { return variant.options[index] === value; });
        }) || null;
      }
      return variants.find(function (variant) { return String(variant.id) === String(idInput.value); }) || null;
    }

    function paint(variant) {
      if (!variant) return;
      idInput.value = variant.id;
      form.querySelectorAll("[data-variant-id]").forEach(function (btn) {
        btn.setAttribute("aria-pressed", String(btn.dataset.variantId) === String(variant.id) ? "true" : "false");
      });
      var label = formatMoney(variant.price);
      if (priceEl) priceEl.textContent = label;
      if (priceMobile) priceMobile.textContent = label;
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.hidden = false;
          compareEl.textContent = formatMoney(variant.compare_at_price);
        } else {
          compareEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? "Add to cart" : "Sold out";
      }
      if (variant.featured_media && variant.featured_media.id) bbShowMedia(variant.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      history.replaceState({}, "", url);
    }

    if (new URL(window.location.href).searchParams.get("variant")) {
      var initial = currentVariant();
      if (initial && initial.featured_media && initial.featured_media.id) {
        setTimeout(function () { bbShowMedia(initial.featured_media.id); }, 0);
      }
    }
    form.querySelectorAll("[data-variant-id]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var variant = variants.find(function (item) { return String(item.id) === String(btn.dataset.variantId); });
        paint(variant);
      });
    });
    optionSelects.forEach(function (sel) {
      sel.addEventListener("change", function () { paint(currentVariant()); });
    });

    form.addEventListener("submit", function (event) {
      var submitter = event.submitter;
      if (submitter && submitter.name && submitter.name !== "add") return;
      event.preventDefault();
      if (!addBtn || addBtn.disabled) return;
      var qtyInput = form.querySelector("[name='quantity']");
      addBtn.disabled = true;
      var original = addBtn.textContent;
      addBtn.textContent = "Adding...";
      addVariant(Number(idInput.value), Number(qtyInput ? qtyInput.value : 1)).then(function (cart) {
        renderCart(cart);
        setCartOpen(true);
        addBtn.textContent = original;
        addBtn.disabled = false;
      }).catch(function () {
        addBtn.textContent = "Try that again";
        addBtn.disabled = false;
      });
    });

    var buybar = document.querySelector("[data-buybar]");
    var buybarBtn = document.querySelector("[data-buybar-btn]");
    if (buybar && addBtn && "IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function (entries) {
        buybar.classList.toggle("is-on", !entries[0].isIntersecting);
      }, { threshold: 0.2 });
      observer.observe(addBtn);
    }
    if (buybarBtn && addBtn) {
      buybarBtn.addEventListener("click", function () { addBtn.click(); });
    }
  }
  function bbShowMedia(mediaId) {
    var g = document.querySelector("[data-gallery]");
    if (!g || !mediaId) return;
    var target = g.querySelector('[data-media-id="' + mediaId + '"]');
    if (!target) return;
    g.querySelectorAll("[data-media-id]").forEach(function (slide) { slide.hidden = slide !== target; });
    g.querySelectorAll("[data-thumb]").forEach(function (btn) {
      var on = String(btn.dataset.thumb) === String(mediaId);
      btn.setAttribute("aria-current", on ? "true" : "false");
      if (on && btn.scrollIntoView && btn.parentElement && btn.parentElement.scrollWidth > btn.parentElement.clientWidth) {
        btn.parentElement.scrollTo({ left: btn.offsetLeft - 8, behavior: "smooth" });
      }
    });
  }
  initProduct();

  var gallery = document.querySelector("[data-gallery]");
  if (gallery) {
    var slides = gallery.querySelectorAll("[data-media-id]");
    gallery.querySelectorAll("[data-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        slides.forEach(function (slide) {
          slide.hidden = slide.dataset.mediaId !== thumb.dataset.thumb;
        });
        gallery.querySelectorAll("[data-thumb]").forEach(function (btn) {
          btn.setAttribute("aria-current", btn === thumb ? "true" : "false");
        });
      });
    });
  }

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce) {
    document.querySelectorAll(".bb-how__video").forEach(function (video) {
      video.removeAttribute("autoplay");
      video.pause();
    });
  }
  var mobileHow = window.matchMedia("(max-width: 989px)");
  if (reduce) {
    document.querySelectorAll(".bb-how__video").forEach(function (video) {
      video.removeAttribute("autoplay");
      video.pause();
    });
  }
  var scenes = Array.prototype.slice.call(document.querySelectorAll("[data-scene]"));
  var sceneItems = scenes.map(function (scene) {
    return {
      scene: scene,
      fades: Array.prototype.slice.call(scene.querySelectorAll("[data-fade]")),
      steps: Array.prototype.slice.call(scene.querySelectorAll("[data-step]")),
      scales: Array.prototype.slice.call(scene.querySelectorAll("[data-scale]")),
      bar: scene.querySelector("[data-bar] span")
    };
  });
  var raf = 0;
  function tick() {
    raf = 0;
    if (topbar) topbar.classList.toggle("is-scrolled", window.scrollY > 8);
    if (reduce || !sceneItems.length) return;
    var vh = window.innerHeight;
    sceneItems.forEach(function (item) {
      var staticHow = item.scene.classList.contains("bb-scene--how") && mobileHow.matches;
      if (staticHow) {
        item.steps.forEach(function (el) {
          el.style.opacity = "1";
          el.style.visibility = "visible";
          el.style.transform = "none";
        });
        if (item.bar) item.bar.style.transform = "none";
        return;
      }
      var rect = item.scene.getBoundingClientRect();
      if (rect.bottom < -500 || rect.top > vh + 500) return;
      var total = item.scene.offsetHeight - vh;
      var p = total <= 0 ? 0 : clamp(-rect.top / total, 0, 1);
      item.scales.forEach(function (el) {
        var parts = (el.dataset.scale || "1,1").split(",");
        var a = parseFloat(parts[0]);
        var b = parseFloat(parts[1]);
        el.style.transform = "scale(" + (a + (b - a) * p).toFixed(4) + ")";
      });
      item.fades.forEach(function (el) {
        var o = gate(p, parseFloat(el.dataset.from || "0"), parseFloat(el.dataset.to || "1"));
        el.style.opacity = o.toFixed(3);
        el.style.transform = "translate3d(0," + ((1 - o) * 18).toFixed(2) + "px,0)";
      });
      if (item.scene.classList.contains("bb-scene--how")) {
        slideHowSteps(item.steps, p);
      } else {
        item.steps.forEach(function (el) {
          var o = gate(p, parseFloat(el.dataset.from || "0"), parseFloat(el.dataset.to || "1"));
          el.style.opacity = o.toFixed(3);
          el.style.transform = "translate3d(0," + ((1 - o) * 16).toFixed(2) + "px,0)";
        });
      }
      if (item.bar) item.bar.style.transform = "scaleX(" + p.toFixed(4) + ")";
    });
  }
  function slideHowSteps(steps, p) {
    var n = steps.length || 1;
    var travel = 0.1;
    var desktopHow = window.matchMedia("(min-width: 990px)").matches;
    steps.forEach(function (el, index) {
      var start = index / n;
      var end = (index + 1) / n;
      var y = 100;
      var on = false;
      if (index > 0 && p >= start - travel && p < start) {
        var enter = (p - (start - travel)) / travel;
        y = (1 - enter) * 100;
        on = true;
      } else if (p >= start && (index === n - 1 || p < end - travel)) {
        y = 0;
        on = true;
      } else if (index < n - 1 && p >= end - travel && p < end) {
        var exit = (p - (end - travel)) / travel;
        y = -exit * 100;
        on = true;
      } else if (p >= end) {
        y = -100;
      }
      el.style.opacity = "1";
      el.style.visibility = on ? "visible" : "hidden";
      el.style.transform = "translate3d(0," + y.toFixed(2) + "%,0)";
      /* Desktop: subtext fades out faster than the verb on upward exit */
      var sub = el.querySelector(".bb-how__sub");
      if (sub) {
        if (!desktopHow) {
          sub.style.opacity = "";
        } else if (y < 0) {
          var t = Math.min(1, (-y) / 38);
          sub.style.opacity = Math.max(0, 1 - t * (0.55 + 0.45 * t)).toFixed(3);
        } else {
          sub.style.opacity = "1";
        }
      }
    });
  }

  function onScroll() {
    if (!raf) raf = requestAnimationFrame(tick);
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  tick();
})();
